import React from "react";
import { withStyles } from "@material-ui/styles";
import { map } from "lodash";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Popper from "@material-ui/core/Popper";

import colors from "../../../assets/style/colors";
import BreadcrumbItem from "./BreadcrumbItem";

const styles = {
  link: {
    color: colors.primary,
    cursor: "pointer",
    "& :hover": {
      textDecoration: "underline",
    },
  },
  paper: {
    padding: "0px 12px 12px",
    width: "fit-content",
    backgroundColor: colors.white,
    boxShadow: `0px 0px 4px 0px ${colors.black24}`,
    borderRadius: "4px",
  },
};

const BreadcrumbEllipse = (props) => {
  const { classes, items } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mouseOverButton, setMouseOverButton] = React.useState(false);
  const [mouseOverMenu, setMouseOverMenu] = React.useState(false);

  const handleClose = () => {
    setMouseOverButton(false);
    setMouseOverMenu(false);
  };
  const enterButton = (event) => {
    setAnchorEl(event.currentTarget);
    setMouseOverButton(true);
  };

  const leaveButton = () => {
    // Set a timeout so that the menu doesn't close before the user has time to
    // move their mouse over it
    setTimeout(() => {
      setMouseOverButton(false);
    }, 100);
  };

  const enterMenu = () => {
    setMouseOverMenu(true);
  };

  const leaveMenu = () => {
    setMouseOverMenu(false);
  };

  let open = mouseOverButton || mouseOverMenu;

  return (
    <Box>
      <Box
        className={classes.link}
        onMouseEnter={enterButton}
        onTouchStart={enterButton}
        onMouseLeave={leaveButton}
      >
        ...
      </Box>
      <Popper
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
        onClose={handleClose}
        style={{ zIndex: 9999 }}
      >
        <Grid
          container
          className={classes.paper}
          direction="column"
          onMouseEnter={enterMenu}
          onMouseLeave={leaveMenu}
        >
          {map(items, (item, index) => (
            <Grid
              item
              key={index}
              style={{ paddingLeft: index * 24, marginTop: "12px" }}
            >
              <BreadcrumbItem
                key={index}
                item={item}
                pathSize={1}
                itemMaxWidth={500}
              />
            </Grid>
          ))}
        </Grid>
      </Popper>
    </Box>
  );
};

export default withStyles(styles)(BreadcrumbEllipse);
